import {
    COLOR,
    HEIGHT,
    LENGTH,
    MATERIAL,
    MEASUREMENT,
    PACKAGE_QUANTITY,
    VARIANT_VALUES,
    VOLUME,
    WEIGHT,
    WIDTH,
} from "theme/components/productPage/constants";

import { isEmpty } from "core-web/utils/object";

export const getAllVariantValues = (product, codes, searchAllParametrics = false, searchForTemporaries = true) => {
    let codesAsArray = codes;
    if (typeof codes === "string") {
        codesAsArray = [codes];
    }

    let foundParametrics = (product.variants || []).reduce((allValues, variant) => {
        allValues = allValues.concat(
            (searchAllParametrics
                ? variant.parametrics.concat(variant.variant_parametrics)
                : variant.parametrics
            ).filter(
                (parametric) =>
                    codesAsArray.includes(parametric.code) && parametric.value_2 && parametric.value_2 !== "0",
            ),
        );

        return allValues;
    }, []);

    if (searchForTemporaries && !foundParametrics?.length) {
        foundParametrics = (product.variants || []).reduce((allValues, variant) => {
            allValues = allValues.concat(
                (searchAllParametrics
                    ? variant.parametrics.concat(variant.variant_parametrics)
                    : variant.parametrics
                ).filter(
                    (parametric) =>
                        codesAsArray.map((code) => `${code}_text`).includes(parametric.code) &&
                        parametric.value_2 &&
                        parametric.value_2 !== "0",
                ),
            );

            return allValues;
        }, []);
    }

    return foundParametrics;
};

export const getFirstVariantValue = (variants = [], codes = [], getAsArray) => {
    let foundParametrics;
    variants.forEach((variant) => {
        foundParametrics = variant.parametrics.filter(
            (parametric) =>
                (typeof codes === "string" ? codes === parametric.code : codes.includes(parametric.code)) &&
                parametric.value_2 &&
                parametric.value_2 !== "0",
        );
    });

    if (!foundParametrics?.length) {
        variants.forEach((variant) => {
            foundParametrics = variant.parametrics.filter(
                (parametric) =>
                    (typeof codes === "string"
                        ? `${codes}_text` === parametric.code
                        : codes.map((code) => `${code}_text`).includes(parametric.code)) &&
                    parametric.value_2 &&
                    parametric.value_2 !== "0",
            );
        });
    }

    if (!foundParametrics?.length) {
        return null;
    }

    return getAsArray ? foundParametrics : foundParametrics?.[0];
};

export const getParametrics = (parametrics = [], codes, getAsArray = false, searchForTemporaries = true) => {
    let foundParametrics = parametrics.filter(
        (parametric) =>
            (typeof codes === "string" ? codes === parametric.code : codes.includes(parametric.code)) &&
            parametric.value_2 &&
            parametric.value_2 !== "0",
    );

    if (searchForTemporaries && !foundParametrics?.length) {
        foundParametrics = parametrics.filter(
            (parametric) =>
                (typeof codes === "string"
                    ? `${codes}_text` === parametric.code
                    : codes.map((code) => `${code}_text`).includes(parametric.code)) &&
                parametric.value_2 &&
                parametric.value_2 !== "0",
        );
    }

    if (!foundParametrics?.length) {
        return null;
    }

    return getAsArray ? foundParametrics : foundParametrics?.[0];
};

export const filterOutDuplicates = (array, key) => {
    return array.reduce(
        (filteredArray, value) =>
            (key ? filteredArray.every((filtered) => filtered[key] !== value[key]) : !filteredArray.includes(value))
                ? [...filteredArray, value]
                : filteredArray,
        [],
    );
};

export const getProductListInfo = (product, selectedVariant) => {
    const listInfo = [];
    const partNos = selectedVariant
        ? [selectedVariant.part_no]
        : product.variants?.map((variant) => variant.part_no) || [product.part_no];
    if (partNos?.length && partNos.length <= 5) {
        listInfo.push({ key: "partNos", values: partNos });
    }

    // const categories = product.categories?.map((category) => {
    //     const label = category.format?.name;
    //     const url = category.format?.permalink;
    //     return { label, url };
    // });
    // if (categories?.length) {
    //     listInfo.push({ key: "categories", values: categories });
    // }

    // const manufacturer = product.manufacturer || {};
    // if (!isEmpty(manufacturer)) {
    //     const manufacturerSlug = manufacturer.format?.slug || null;
    //     const label = manufacturer.name;
    //     listInfo.push({ key: "manufacturer", values: [{ url: manufacturerSlug, label }] });
    // }

    // const manufacturerPartNos = selectedVariant
    //     ? [selectedVariant.manufacturer?.part_no]
    //     : product.variants?.map((variant) => variant.manufacturer?.part_no) || [product.manufacturer?.part_no];
    // if (manufacturerPartNos?.length && manufacturerPartNos.length <= 5) {
    //     listInfo.push({ key: "manufacturer_part_no", values: manufacturerPartNos });
    // }

    const variantSizes = selectedVariant
        ? getParametrics(
              (selectedVariant.parametrics || []).concat(selectedVariant.variant_parametrics || []),
              VARIANT_VALUES,
              true,
          )?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, VARIANT_VALUES, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(
              getAllVariantValues(product, VARIANT_VALUES, true)?.map((parametric) => parametric.value),
          );
    if (variantSizes?.length) {
        listInfo.push({ key: "sizes", values: variantSizes });
    }

    const colors = selectedVariant
        ? getParametrics(
              (selectedVariant.parametrics || []).concat(selectedVariant.variant_parametrics || []),
              COLOR,
              true,
          )?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, COLOR, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, COLOR, true)?.map((parametric) => parametric.value));
    if (colors?.length) {
        listInfo.push({ key: "colors", values: colors });
    }

    const width = selectedVariant
        ? getParametrics(selectedVariant.parametrics, WIDTH, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, WIDTH, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, WIDTH, true)?.map((parametric) => parametric.value));
    if (width?.length) {
        listInfo.push({ key: "width", values: width });
    }

    const height = selectedVariant
        ? getParametrics(selectedVariant.parametrics, HEIGHT, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, HEIGHT, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, HEIGHT, true)?.map((parametric) => parametric.value));
    if (height?.length) {
        listInfo.push({ key: "height", values: height });
    }

    const length = selectedVariant
        ? getParametrics(selectedVariant.parametrics, LENGTH, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, LENGTH, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, LENGTH, true)?.map((parametric) => parametric.value));
    if (length?.length) {
        listInfo.push({ key: "length", values: length });
    }

    const measurement = selectedVariant
        ? getParametrics(selectedVariant.parametrics, MEASUREMENT, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, MEASUREMENT, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, MEASUREMENT, true)?.map((parametric) => parametric.value));
    if (measurement?.length) {
        listInfo.push({ key: "measurement", values: measurement });
    }

    const weight = selectedVariant
        ? getParametrics(selectedVariant.parametrics, WEIGHT, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, WEIGHT, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, WEIGHT, true)?.map((parametric) => parametric.value));
    if (weight?.length) {
        listInfo.push({ key: "weight", values: weight });
    }

    const volume = selectedVariant
        ? getParametrics(selectedVariant.parametrics, VOLUME, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, VOLUME, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, VOLUME, true)?.map((parametric) => parametric.value));
    if (volume?.length) {
        listInfo.push({ key: "volume", values: volume });
    }

    const material = selectedVariant
        ? getParametrics(selectedVariant.parametrics, MATERIAL, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, MATERIAL, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(getAllVariantValues(product, MATERIAL, true)?.map((parametric) => parametric.value));
    if (material?.length) {
        listInfo.push({ key: "material", values: material });
    }

    // const washingLine = selectedVariant
    //     ? getParametrics(selectedVariant.parametrics, WASHING_LINE, true)?.map((parametric) => parametric.value) ||
    //       getParametrics(product.parametrics, WASHING_LINE, true)?.map((parametric) => parametric.value)
    //     : filterOutDuplicates(getAllVariantValues(product, WASHING_LINE, true)?.map((parametric) => parametric.value));
    // if (washingLine?.length) {
    //     listInfo.push({ key: "washing_line", values: washingLine });
    // }

    const packageQuantity = selectedVariant
        ? getParametrics(selectedVariant.parametrics, PACKAGE_QUANTITY, true)?.map((parametric) => parametric.value) ||
          getParametrics(product.parametrics, PACKAGE_QUANTITY, true)?.map((parametric) => parametric.value)
        : filterOutDuplicates(
              getAllVariantValues(product, PACKAGE_QUANTITY, true)?.map((parametric) => parametric.value),
          );
    if (packageQuantity?.length) {
        listInfo.push({ key: "package_quantity", values: packageQuantity });
    }

    // const eanNumbers = selectedVariant
    //     ? [selectedVariant.ean_code]
    //     : product.variants?.map((variant) => variant.ean_code) || [product.ean_code];
    // if (eanNumbers?.length && eanNumbers.length <= 5) {
    //     listInfo.push({ key: "ean_numbers", values: eanNumbers });
    // }

    return listInfo;
};
